import { ThemeToggle as SharedThemeToggle } from '../../shared/theme/ThemeToggle.js'
import { useOwnerTheme } from '../theme/useOwnerTheme.js'

/**
 * Dark / light toggle for the owner + staff header. Thin wrapper wiring the
 * shared presentational `ThemeToggle` to `useOwnerTheme` and the
 * `.owner-theme-toggle` style scope.
 */
export function OwnerThemeToggle() {
  const { theme, toggle } = useOwnerTheme()
  return (
    <SharedThemeToggle
      theme={theme}
      toggle={toggle}
      className="owner-theme-toggle"
    />
  )
}
